import {isValidElement} from 'react'
import {Layout, Text} from '~/components'

const PopoutBodyLayout = ({children, ...rest}) => (
	<Layout className="popout-body" direction="vertical" width="full" {...rest}>
		{children}
	</Layout>
)

export const PopoutBody = ({body, showContentBorders}) => {
	const isElement = isValidElement(body)

	if (isElement) return <PopoutBodyLayout>{body}</PopoutBodyLayout>

	const textProps = _.isString(body) ? {t: body} : body

	const padding = showContentBorders && '12 - - -'

	return (
		<PopoutBodyLayout padding={padding}>
			<Text className="popout-body-text" {...textProps} />
		</PopoutBodyLayout>
	)
}
